import clsx from 'clsx'
import React from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { DashboardLayout, Icon, ThemeIcon } from '../../../components'
import { currencyFmt } from '../../../utils'

import './Transaction.scss'

const Transaction = ({ transaction }) => {
   const history = useHistory()
   const { coinId } = useParams()

   const { isDarkTheme } = useSelector(state => state.theme)

   return (
      <DashboardLayout
         withNav={false}
         className={clsx('Transaction', isDarkTheme && 'Transaction--dark')}
      >
         <header className="Transaction__header">
            <Icon
               className="Transaction__header-back"
               name="chevron-left"
               onClick={() => history.push(`/coin/${coinId}`)}
            />
            <h2
               className={clsx(
                  'Transaction__header-value',
                  transaction.recipient && 'Transaction__header-value--red',
                  transaction.sender && 'Transaction__header-value--green'
               )}
            >
               {transaction.sender ? '+' : '-'} {transaction.value}{' '}
               {transaction.unit}
            </h2>
            <ThemeIcon className="Transaction__header-share" name="share" />
         </header>
         <div className="Transaction__card">
            <div className="Transaction__card-statement">
               <h3 className="Transaction__card-statement-desc">Date</h3>
               <h3 className="Transaction__card-statement-value">
                  {dayjs(transaction.date).format('MMM DD, hh:mm a')}
               </h3>
            </div>
            <div className="Transaction__card-statement">
               <h3 className="Transaction__card-statement-desc">Status</h3>
               <h3 className="Transaction__card-statement-value">
                  {transaction.status}
               </h3>
            </div>
            <div className="Transaction__card-statement">
               <h3 className="Transaction__card-statement-desc">
                  {transaction.sender ? 'Sender' : 'Recipient'}
               </h3>
               <h3
                  className="Transaction__card-statement-value"
                  title={transaction.sender || transaction.recipient}
               >
                  {transaction.sender || transaction.recipient}
               </h3>
            </div>
         </div>
         <div className="Transaction__card">
            <div className="Transaction__card-statement">
               <h3 className="Transaction__card-statement-desc">Network Fee</h3>
               <h3 className="Transaction__card-statement-value">
                  {currencyFmt(transaction.networkFee)}
               </h3>
            </div>
            <div className="Transaction__card-statement">
               <h3 className="Transaction__card-statement-desc">Nonce</h3>
               <h3 className="Transaction__card-statement-value">
                  {transaction.nonce}
               </h3>
            </div>
         </div>
      </DashboardLayout>
   )
}

export default Transaction
